import React, { useState } from "react";
import { Layout, Menu, Button, Typography, Drawer } from "antd";
import {
  MenuOutlined,
  ProjectOutlined,
  CalendarOutlined,
  UserOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";

const { Sider } = Layout;
const { Title } = Typography;

const Sidebar = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);

  return (
    <>
      {/* Tombol Hamburger Menu (Mobile) */}
      <Button
        type="primary"
        icon={<MenuOutlined />}
        onClick={() => setDrawerVisible(true)}
        style={{
          position: "fixed",
          top: 15,
          left: 15,
          zIndex: 1001,
          display: collapsed ? "block" : "none",
          background: "#1890ff",
          borderRadius: "50%",
          width: "45px",
          height: "45px",
          fontSize: "20px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
        }}
      />

      {/* Sidebar (Desktop) */}
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        breakpoint="md" // Auto-collapse jika layar <= 768px
        collapsedWidth={0} // Hilangkan sidebar saat collapse
        width={260}
        style={{
          minHeight: "100vh",
          background: "#001529",
          boxShadow: "2px 0 10px rgba(0, 0, 0, 0.15)",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 1000,
        }}
      >
        {/* Logo & Branding */}
        <div
          style={{
            textAlign: "center",
            padding: "20px",
            borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
          }}
        >
          <Title level={3} style={{ color: "white", margin: 0 }}>
            🚀 DM APPS
          </Title>
          <p style={{ color: "#b0c4de", fontSize: "12px", marginTop: "5px" }}>
            Daily Meeting Management
          </p>
        </div>

        {/* Menu Sidebar */}
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          style={{ background: "#001529", fontSize: "16px" }}
        >
          <Menu.Item key="/dashboard" icon={<ProjectOutlined />}>
            <Link to="/dashboard">Dashboard</Link>
          </Menu.Item>
          <Menu.Item key="/projects" icon={<ProjectOutlined />}>
            <Link to="/projects">Projects</Link>
          </Menu.Item>
          <Menu.Item key="/meetings" icon={<CalendarOutlined />}>
            <Link to="/meetings">Meetings</Link>
          </Menu.Item>
          <Menu.Item key="/meeting-followup" icon={<CalendarOutlined />}>
            <Link to="/meeting-followup">Tindak Lanjut Meeting</Link>
          </Menu.Item>
          <Menu.Item key="/users" icon={<UserOutlined />}>
            <Link to="/users">Users</Link>
          </Menu.Item>
          <Menu.Item key="/report" icon={<FileTextOutlined />}>
            <Link to="/report">Laporan Pelaksanaan</Link>
          </Menu.Item>
        </Menu>
      </Sider>

      {/* Drawer (Mobile) */}
      <Drawer
        title="DM APPS"
        placement="left"
        closable={false}
        onClose={() => setDrawerVisible(false)}
        visible={drawerVisible}
        bodyStyle={{ padding: "0" }}
      >
        <Menu
          mode="inline"
          selectedKeys={[location.pathname]}
          style={{ fontSize: "16px" }}
          onClick={() => setDrawerVisible(false)} // Auto-close saat klik di mobile
        >
          <Menu.Item key="/dashboard" icon={<ProjectOutlined />}>
            <Link to="/dashboard">Dashboard</Link>
          </Menu.Item>
          <Menu.Item key="/projects" icon={<ProjectOutlined />}>
            <Link to="/projects">Projects</Link>
          </Menu.Item>
          <Menu.Item key="/meetings" icon={<CalendarOutlined />}>
            <Link to="/meetings">Meetings</Link>
          </Menu.Item>
          <Menu.Item key="/meeting-followup" icon={<CalendarOutlined />}>
            <Link to="/meeting-followup">Tindak Lanjut Meeting</Link>
          </Menu.Item>
          <Menu.Item key="/users" icon={<UserOutlined />}>
            <Link to="/users">Users</Link>
          </Menu.Item>
          <Menu.Item key="/report" icon={<FileTextOutlined />}>
            <Link to="/report">Laporan Pelaksanaan</Link>
          </Menu.Item>
        </Menu>
      </Drawer>
    </>
  );
};

export default Sidebar;
